export const ADD_IMAGE='ADD_IMAGE'
export const ADD_IMAGE_SUCCESS= 'ADD_IMAGE_SUCCESS'
export const ADD_IMAGE_ERROR= 'ADD_IMAGE_ERROR'

export const AddImage= (data) => ({
    type: ADD_IMAGE,
    payload: data
})